import actionTypes from '../../action-types'

export default (payload, meta, included) => ({
  type: actionTypes.CUSTOMERS.SET_ALL,
  payload,
  meta,
  included,
})
